export default __webpack_public_path__ + "static/media/neptik-blue.0f55b4b8.svg";